const SHOP_ID = 'shopId';

export const storeShopId = (state) => sessionStorage.setItem(SHOP_ID, state);
export const getShopId = () => sessionStorage.getItem(SHOP_ID) || '';
